import { SET_ALERT, REMOVE_ALERT, CLEAR_ALERT, SET_LOADING } from "../types";

const LayoutReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      let progress = "";
      if (
        action.payload.progress ||
        parseFloat(action.payload.progress) === 0
      ) {
        progress = action.payload.progress;
      }
      if (state.loading === action.payload.load) {
        return {
          ...state,
          progress: progress,
        };
      } else {
        return {
          ...state,
          loading: action.payload.load,
          progress: progress,
        };
      }

    case SET_ALERT:
      return { ...state, alerts: [...state.alerts, action.payload] };

    case REMOVE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.payload),
      };

    case CLEAR_ALERT:
      return { ...state, alerts: [] };

    default:
      return state;
  }
};

export default LayoutReducer;